import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: '/',
        name: 'Layout',
        component: () => import('@/layout/index_v2.vue'),
        redirect: '/device',
        children: [
            {
                path: 'device',
                name: 'Device',
                component: ()=>import('@/views/device.vue'),
                meta: {title: '设备管理'}
            },
            {
                path: '/running',
                name: 'Running',
                component: () => import('@/views/running_v2.vue'),
                meta: {title: '运行中心'}
            },
            {
                path: '/debug',
                name: 'Debug',
                component: () => import('@/views/debug.vue'),
                meta: {title: '调试'}
            }
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login.vue')
    }
];


export default new Router({
    mode: 'history', //去掉url上的#
    routes: routes
})